import { createContext, useContext, useState } from "react";

const ServingsContext = createContext(null);

export const ServingsProvider = ({ children }) => {
  const [servings, setServings] = useState(4);
  const [baseServings, setBaseServings] = useState(4);

  return (
    <ServingsContext.Provider value={{ servings, setServings, baseServings, setBaseServings }}>
      {children}
    </ServingsContext.Provider>
  );
};

export const useServings = () => {
  const ctx = useContext(ServingsContext);
  if (!ctx) throw new Error("useServings must be used within ServingsProvider");
  return ctx;
};
